// TODO: WF GOTOWY Tom 1 sample pages (WebP hosted in Impultienda Recursos).
// The "Zajrzyj do środka" section (components/InsidePages.tsx) stays hidden while this list is empty.
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [];
